<template>
  <div class="loading-container">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingContainer'
})
</script>

<style lang="scss" scoped>
@use '@/assets/global-mixins' as *;

.loading-container {
  @include center-absolute-element;
}
</style>
